import { useLocation } from "react-router-dom";
import { useLang } from "@/context/LanguageContext";
import { useSeo } from "@/hooks/useSeo";
import { IMAGES } from "@/lib/site";
import { SITE_URL, SEO_META } from "@/lib/seoMeta";

// Applies SEO-optimised, localized meta for a known page key, with canonical + OG defaults.
export function usePageSeo(key, extra = {}) {
  const { isAr } = useLang();
  const { pathname } = useLocation();
  const entry = SEO_META[key] || {};
  const meta = (isAr ? entry.ar : entry.en) || {};
  const path = entry.path || pathname;

  useSeo({
    title: meta.title,
    description: meta.description,
    image: extra.image || IMAGES.skyline,
    canonical: `${SITE_URL}${path}`,
    locale: isAr ? "ar_AE" : "en_US",
    noindex: extra.noindex,
    jsonLd: extra.jsonLd,
  });
}
